var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectionChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 7.29296C14.5194 7.10549 14.2651 7.00017 14 7.00017C13.7348 7.00017 13.4805 7.10549 13.293 7.29296L9.99997 10.586L6.70697 7.29296C6.61472 7.19745 6.50438 7.12127 6.38237 7.06886C6.26037 7.01645 6.12915 6.98886 5.99637 6.98771C5.86359 6.98655 5.73191 7.01186 5.60901 7.06214C5.48612 7.11242 5.37446 7.18667 5.28057 7.28056C5.18668 7.37446 5.11243 7.48611 5.06215 7.609C5.01186 7.7319 4.98656 7.86358 4.98772 7.99636C4.98887 8.12914 5.01646 8.26036 5.06887 8.38236C5.12127 8.50437 5.19746 8.61471 5.29297 8.70696L9.29297 12.707C9.4805 12.8944 9.7348 12.9997 9.99997 12.9997C10.2651 12.9997 10.5194 12.8944 10.707 12.707L14.707 8.70696C14.8944 8.51943 14.9998 8.26512 14.9998 7.99996C14.9998 7.73479 14.8944 7.48049 14.707 7.29296Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionChevron);
export default __webpack_public_path__ + "static/media/selection-chevron.6132371ca82ae200f7d37b8c7a20bf03.svg";
export { ForwardRef as ReactComponent };